import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Box, Typography, CircularProgress, Button, Paper, Stack } from '@mui/material';
import { useAuth } from '../hooks/useAuth';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated, isLoading, user } = useAuth() as any;
  const [showLoginButton, setShowLoginButton] = useState(false);
  const search = new URLSearchParams(location.search);
  const requestedReturnUrl = search.get('returnUrl') || '/';

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.debug('[LoginPage] render', {
        path: location.pathname,
        search: location.search,
        isAuthenticated,
        isLoading,
        user,
        showLoginButton,
        requestedReturnUrl,
        roles: user?.roles,
      });
    }

    if (isAuthenticated) {
      navigate('/', { replace: true });
      return;
    }

    if (!showLoginButton) {
      setShowLoginButton(true);
    }
  }, [isAuthenticated, navigate, showLoginButton]);

  const handleLoginClick = async () => {
    try {
      await login(requestedReturnUrl);
    } catch (error) {
      console.error('Failed to redirect to Keycloak:', error);
    }
  };

  return (
    <Container component="main" maxWidth="sm" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Paper elevation={6} sx={{ width: '100%', p: 4, borderRadius: 3 }}>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <Typography variant="overline" color="primary" letterSpacing={1}>
            Central DB Admin
          </Typography>
          <Typography variant="h4" component="h1" fontWeight={700}>
            Sign in to continue
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Use your Optima SSO account to access Central DB tooling.
          </Typography>

          {showLoginButton ? (
            <Button variant="contained" size="large" onClick={handleLoginClick} sx={{ mt: 1 }}>
              Login with SSO
            </Button>
          ) : (
            <Box sx={{ py: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
              <CircularProgress size={48} />
              <Typography variant="body2" color="text.secondary">
                Redirecting to login...
              </Typography>
            </Box>
          )}
        </Stack>
      </Paper>
    </Container>
  );
};

export default LoginPage;

